import { financialPlanResource, FinancialPlanResource } from '@/resources/financialPlan.resource';
import { AbstractModule } from './abstract.module';

/**
 * Moduł planów finansowych
 *
 * @export
 * @class FinancialPlanModule
 * @extends {AbstractModule<FinancialPlanResource>}
 */
export class FinancialPlanModule extends AbstractModule<FinancialPlanResource> {
  public state = { records: [] };

  public actions = {
    /**
     * Pobranie planu
     *
     * @param {*} context
     * @param {Promise<Array<{ name: string; amount: number, comment: '' }>>} filters
     */
    getFinancialPlan: (context: any, filters: any): Promise<Array<{ name: string; amount: number; comment: '' }>> =>
      this.resource
        .getFinancialPlan(filters)
        .then(records => records.map(record => ({ ...record, comment: '' as const })))
        .then(records => {
          context.commit('saveRecords', records);
          return records;
        }),

    /**
     * Przesyła plan do MDOK
     *
     * @param {*} context
     * @param {*} data
     * @returns {Promise<boolean>}
     */
    sendToMdok: (context: any, data: any): Promise<boolean> => this.resource.sendToMdok(data)
  };

  public mutations = {
    /**
     * Zapis planu
     *
     * @param {*} localState
     * @param {Array<{ name: string; amount: number }>} records
     */
    saveRecords: (localState: any, records: Array<{ name: string; amount: number }>): void => {
      localState.records = records;
    }
  };
}

export default new FinancialPlanModule(financialPlanResource);
